var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgClient = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "building-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.1667 18.9583H0.833332C0.491666 18.9583 0.208332 18.675 0.208332 18.3333C0.208332 17.9917 0.491666 17.7083 0.833332 17.7083H19.1667C19.5083 17.7083 19.7917 17.9917 19.7917 18.3333C19.7917 18.675 19.5083 18.9583 19.1667 18.9583Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.4836 18.9667C16.1419 18.9667 15.8586 18.6834 15.8586 18.3417V14.625C15.8586 14.2834 16.1419 14 16.4836 14C16.8252 14 17.1086 14.2834 17.1086 14.625V18.3417C17.1086 18.6834 16.8336 18.9667 16.4836 18.9667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16.5001 15.25C15.1418 15.25 14.0417 14.15 14.0417 12.7916V10.9C14.0417 9.54168 15.1418 8.44167 16.5001 8.44167C17.8584 8.44167 18.9584 9.54168 18.9584 10.9V12.7916C18.9584 14.15 17.8584 15.25 16.5001 15.25ZM16.5001 9.70001C15.8334 9.70001 15.2917 10.2417 15.2917 10.9084V12.8C15.2917 13.4667 15.8334 14.0083 16.5001 14.0083C17.1668 14.0083 17.7084 13.4667 17.7084 12.8V10.9084C17.7084 10.2417 17.1668 9.70001 16.5001 9.70001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M11.9165 18.9583C11.5748 18.9583 11.2915 18.675 11.2915 18.3333V5.02502C11.2915 3.70002 10.7332 3.13334 9.43319 3.13334H4.24154C2.9332 3.13334 2.36654 3.70002 2.36654 5.02502V18.3333C2.36654 18.675 2.0832 18.9583 1.74154 18.9583C1.39987 18.9583 1.11654 18.675 1.11654 18.3333V5.02502C1.11654 3.00003 2.22487 1.88334 4.24154 1.88334H9.43319C11.4415 1.88334 12.5415 3.00003 12.5415 5.02502V18.3333C12.5415 18.675 12.2582 18.9583 11.9165 18.9583Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M8.95818 7.5H4.83317C4.4915 7.5 4.20817 7.21667 4.20817 6.875C4.20817 6.53333 4.4915 6.25 4.83317 6.25H8.95818C9.29985 6.25 9.58318 6.53333 9.58318 6.875C9.58318 7.21667 9.29985 7.5 8.95818 7.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M8.95818 10.625H4.83317C4.4915 10.625 4.20817 10.3417 4.20817 10C4.20817 9.65833 4.4915 9.375 4.83317 9.375H8.95818C9.29985 9.375 9.58318 9.65833 9.58318 10C9.58318 10.3417 9.29985 10.625 8.95818 10.625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M6.875 18.9583C6.53333 18.9583 6.25 18.675 6.25 18.3333V15.2083C6.25 14.8667 6.53333 14.5833 6.875 14.5833C7.21667 14.5833 7.5 14.8667 7.5 15.2083V18.3333C7.5 18.675 7.21667 18.9583 6.875 18.9583Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_8",
    opacity: 0
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgClient);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/client.eefae4a075d611dff6b348080af81b45.svg";